// Centralized amenities configuration for BOOTH
// Owners can select from these or add custom amenities

import { Wifi, Car, Wind, Tv, Coffee, Armchair, Accessibility, Music, CreditCard, Calendar, Users, Droplets, Flame, Refrigerator, BookOpen, Speaker, Lock, Bath, Utensils, ShieldCheck, Sparkles, Type as type, LucideIcon } from "lucide-react"

export interface AmenityConfig {
  id: string
  label: string
  icon: LucideIcon
  category: "essentials" | "comfort" | "premium" | "services"
}

export const AMENITIES: AmenityConfig[] = [
  // Essentials
  { id: "wifi", label: "WiFi", icon: Wifi, category: "essentials" },
  { id: "parking", label: "Parking", icon: Car, category: "essentials" },
  { id: "ac", label: "Air Conditioning", icon: Wind, category: "essentials" },
  { id: "wheelchair", label: "Wheelchair Access", icon: Accessibility, category: "essentials" },
  { id: "restrooms", label: "Restroom", icon: Bath, category: "essentials" },

  // Comfort
  { id: "waiting-area", label: "Waiting Area", icon: Users, category: "comfort" },
  { id: "leather-sofa", label: "Leather Sofa", icon: Armchair, category: "comfort" },
  { id: "washbowl", label: "Washbowl", icon: Droplets, category: "comfort" },
  { id: "towels", label: "Towel Service", icon: Sparkles, category: "comfort" },
  { id: "incense", label: "Incense", icon: Flame, category: "comfort" },

  // Premium
  { id: "smart-tv", label: "Smart TV", icon: Tv, category: "premium" },
  { id: "bluetooth-speaker", label: "Bluetooth Speaker", icon: Speaker, category: "premium" },
  { id: "music-system", label: "Music System", icon: Music, category: "premium" },
  { id: "mini-fridge", label: "Mini-Fridge", icon: Refrigerator, category: "premium" },
  { id: "coffee-bar", label: "Mini Coffee Bar", icon: Coffee, category: "premium" },
  { id: "refreshments", label: "Refreshments", icon: Coffee, category: "premium" },
  { id: "books-magazines", label: "Books & Magazines", icon: BookOpen, category: "premium" },
  { id: "kitchenette", label: "Kitchenette", icon: Utensils, category: "premium" },
  { id: "private-experience", label: "Private Experience", icon: Lock, category: "premium" },

  // Services
  { id: "card-payments", label: "Card Payments", icon: CreditCard, category: "services" },
  { id: "appointment-system", label: "Appointment System", icon: Calendar, category: "services" },
  { id: "walk-ins", label: "Walk-ins Welcome", icon: Users, category: "services" },
  { id: "workstations", label: "Workstations", icon: Armchair, category: "services" },
  { id: "video-security", label: "Video Security", icon: ShieldCheck, category: "services" },
  { id: "lockers", label: "Lockers", icon: Lock, category: "services" },
]

export const AMENITY_CATEGORIES = {
  essentials: "Essentials",
  comfort: "Comfort",
  premium: "Premium",
  services: "Services",
}

export function getAmenityByLabel(label: string): AmenityConfig | undefined {
  return AMENITIES.find((a) => a.label.toLowerCase() === label.toLowerCase())
}

export function getAmenityById(id: string): AmenityConfig | undefined {
  return AMENITIES.find((a) => a.id === id)
}
